// extracted by mini-css-extract-plugin
export var searchHeader = "_2z-0";
export var searchHeaderDark = "_2z-1";